import React from 'react'

import LoadingBox from 'src/ui/LoadingBox/LoadingBox'
import { Flex } from '@chatterbug/aaron'

import CertListSkeleton from './CertListSkeleton'

const CertListPlaceholder = () => {
  return (
    <CertListSkeleton
      certItemsSection={[...Array(3)].map((e, i) => (
        <Flex key={`cert-list-placeholder-${i}`} mb="1x">
          <LoadingBox width="40px" height="40px" borderRadius="40px" mr="1x" />
          <LoadingBox width="50%" height="40px" borderRadius="1x" />
        </Flex>
      ))}
    />
  )
}

export default CertListPlaceholder
